// 最大id已使用到11
const config = {
  title: '异常问题',
  id: '4',
  list: [
    {
      title: '关于暂未查到相关信息的账号安全分析？',
      id: '0',
      content: `快现形从2020年开始监测买家的评论变化。<br/>
      如果显示未查到信息，说明要么该账号在被收录前被彻底撸评；要么被收录时属于从来没有留评的群体，有将近60%的亚马逊买家从来没有留过一个评论，如果找的是真正的普通老外、素人账号，大概率会遇到这种情况，是非常优质账号。<br/>
      一旦显示暂未查到信息，可通过购买记录、留评记录详细分析，判断是新号、老号、还是自养号，判断是否可以用。<br/>
      <b>一、针对从来没有留过评论的买家：</b><br/>
      可查看买家最早的购买订单的时间；<br/>
      如果少于6个月可能是自养号、新号，在美国等成熟站点，尽量不用。<br/>
      如果是6-12个月之间，可能是自养号、新号，在美国等成熟站点，谨慎用。<br/>
      如果大于12个月，且有多次购买记录，很可能是老号，属于从不留评群体（60%的亚马逊买家从来没有留过一个评论），可以视为安全、比较安全账号。<br/>
      备注：<br/>
      1、自养号一般不会出现养了1年多，还没有留过评的情况，因为养号非常太高，不做留评单，成本划不来。<br/>
      2、2020年之前被撸空评论的买家，继续做留评的概率也很低。<br/>
      <b>二、针对最近半年有留过评论的买家：</b><br/>
      同样是查看买家最早的购买订单的时间；<br/>
      如果少于6个月，且有留评，大概率是自养号，视为危险账号，不能测评。<br/>
      如果是6-12个月之间，且有留评，可能是自养号、新号，在美国等成熟站点，慎用。<br/>
      如果大于1年，且有多次购买记录，且最近有留评，很可能是老号，可以视为安全、比较安全账号。此种情况下，即使某一段时间出现评论较多也影响不大，因为该账号一直在亚马逊系统中属于素人账号，是安全、比较安全账号类型。
      <br/>`,
    },
    {
      title: '快现形数据是怎么核算的，是否及时，能不能作为最终参考？',
      id: '1',
      content: `我们是数据分析结果绝对可以作为你测评参考的标准。<br/>
我们数据会及时更新的，按照不同指标类型会每天、每周更新。<br/>
针对你查过的Profile ID，我们会第一时间展示给你我们最新的结果；另外，我们会再次针对你查询的Profile ID，在24小时内，再次核对该账号所有数据，并且在24小时后，再次给到一个最新结果。如果数据有变化，我们会给出提示。<br/>
另外，由于全网数据量太大，部分指标与正常的买家账号我们是每周更新一次，可能存在一定的账号最近一周的评价信息没有及时统计进去。<br/>
不过大家可以绝对放心，如果这个买家历史记录是安全的，最近一周的结果是不会对账号短时间有任何影响的。<br/>`,
    },
    {
      title: '在哪里可以看账号的24小时内更新的最新数据？',
      id: '2',
      content: `进入快现形（www.kuaixianxing.com），登录账号后，点开“我的账号”，再点开“查询记录”即可看到你查询过的账号，在你查完账号后的24小时内，我们会对该账号完成最新更新。<br/>
如果你对哪个账号有疑问，可以再点击“重新查询”，你就能看到最新的账号检测结果，该次重新查询免费。
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf6000.png" style="height:216px; width:554px"></p>
备注：实际上快现形可能在你查完账号的4小时内就完成更新，如果你对账号很看重，你可以及时关注。`,
    },
    {
      title: '为什么我的买家账号在快现形上查不到？',
      id: '3',
      content: `导致买家账号在快现形上查不到，主要有以下三个原因：<br/>
1、该买家一直将账号隐藏，这样的账号是危险的，不能用；<br/>
2、这是从没有留过评论的买家账号<br/>
3、买家刚注册，所以没有查到。
4、系统数据量比较大，更新不及时，几个小时之后可以再次查询！
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf6001.png" style="height:176px; width:553px"></p>`,
    },
    {
      title: '为什么我在快现形查出来的极度危险的账号/危险账号，也有一些账号能够留评，是不是你们账号分析不准？',
      id: '10',
      content: `极度危险的账号/危险的账号，建议你尽量不要用，这个无异于饮鸩止渴。
      <br/>为什么这些账号在你店铺里面留的评论没有被删，原因很简单，举个例子，一个杀人犯从牢房里放出来了，最近他又作案了，要么警察有其他事情还没有顾得上他；要么警察已经怀疑他又犯案子了，但是现在证据还不充分，或者说现在这个人还没被查到，还没触发报警，所以暂时是安全的，但并不代表不会抓他。
      <br/>账号也是一样，如果Listing现在相对是安全的，或者还没有查出来，或者这个账号这一小段时间表现相对正常，那只是现在没查出来或者还没有触发平台的综合稽查系统而已。/危险账号，也有一些账号能够留评，是不是你们账号分析不准？`
    },
    {
      title: '为什么我在快现形查的安全账号/比较安全账号推广，也有被删评的情况，是不是你们数据不准？',
      id: '11',
      content: `我们对账号的安全度做了30多个层面的分析，得出了安全、比较安全、有一定风险、危险、极度危险的分层；危险级别越高，被抓的可能性越大。
      <br/>而有时出现安全、比较安全账号被删评，也是亚马逊平台从自己的系统分析该listing数据极度异常，才做出删评。
      <br/>就比如说你是好市民，是不是有时候在路上也会被警察看到后要查你身份证，或者不小心卷入某些麻烦事情得去公安局做笔录。
      <br/>总体来说，如果都是用安全、比较安全账号，或者少量风险账号，基本上比较难处罚平台的。`,
    },
    {
      title: '为什么我通过昵称、helpful、reviews，就是查不到账号？',
      id: '4',
      content: `查号验号建议直接买家Profile页面链接查询；如果买家实在不愿意给，可以用买家profile页面上的信息查询（昵称+helpfulvotes+reviews+地址+最近留评时间五项整合查询）。<br/>
建议先填写昵称+helpfulvotes+reviews+地址（没有地址可以不填），如果显示查询结果超过5个，会查不出结果。
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf6002.png" style="height:171px; width:554px"></P>
建议再把Review Date中选择最新的评论时间，或者3个月前的评论时间，多次测试确认。如果还是没有结果，建议直接向买家要求给出买家公开的Profile页面链接，用链接或者ID查。<br/>
为什么会出现查询不出，可能原因如下：<br/>
1、如果买家昵称为Amazon Customer等通用名字，叫这类昵称的在亚马逊有几百万人，并且买家的helpful votes、reviews数字也都是在0、1、2、3，因此可能存在众多账号查不出精准结果。<br/>
2、该买家是最新注册买家，还从没有评论过。<br/>
3、该买家评论被亚马逊全部删掉了，根本没有数据了。<br/>
4、该买家最近短时间的helpful votes、reviews变化过大，造成查询不到。<br/>`,
    },
    {
      title: '为什么买家profile页面没有看出删评，但快现形显示被删2条？',
      id: '5',
      content: `大家看到的快现形页面所有的数据，我们都是有原始数据依据的。<br/>
如果大家发现被删评论或者其它数据，自己计算的结果与快现形有出入，造成原因如下：<br/>
1、有最新的被删评论还没有统计进来；快现形根据不同的账号等级，按照每天/每周等不同频率进行更新的，因此部分账号有数据偏差，但是类似于删除评价、给差评数等指标，大家在买家页面上分析的数据，原则上是大于快现形统计的数据的，因此这个数据可以完全作为参考。<br/>
2、买家整个账号所有信息被删除或者隐藏，导致没法核算，这个时候直接参考快现形数据。<br/>
而题目中的问题，大家可以参考下图：
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211026/uf6500.png" style="height:337px; width:376px"></p>
另外如果针对数据与实际显示有差异，我们也会在24小时内给您更新的买家账号报告，您到时再次查询也不会重新扣费！`,
    },
    {
      title: '为什么买家profile页面只被删了1条，但快现形显示被删4条？',
      id: '6',
      content: `该买家账号异常，该买家快现形数据库中有12条评论，但是在买家的Profile页面显示只有9条，而下面实际展示出来的评论是8条。<br/>
表面上大家自己看是该买家有9条评论，展示8条，另外第九条评论要么属于隐藏没有展示（很少发生）、要么属于被删除，也就是最多被删了1条评论。<br/>
但是按照快现形整理的真实数据，该买家实际留评是12条，现在只有8条，显示的被删评论数最多4条。<br/>
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf6003.png" style="height:316px; width:367px"></p>
大家在查号的过程中，会出现不少类似的异常情况，大家可以以快现形的评判结果为准。<br/>
另外，一旦看到不符合逻辑的异常数据，建议大家直接将这样的数据归结为危险账号。`,
    },
    {
      title: '为什么最近一年买家评论反而比买家全部评论少？',
      id: '7',
      content: `
比如该账号在快现形数据库就是有14条评论，出现这种情况，可能由于以下原因造成：<br/>
1、该买家的2个评论被亚马逊删除。<br/>
2、该买家自己删掉了2个评论。<br/>
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211025/uf6004.png" style="height:222px; width:450px"></p>`,
    },
    {
      title:
        '为什么快现形上最近半年买家留评条数，与买家Profile页面看到的数字不一样？  ',
      id: '8',
      content: `不一样，主要有以下几个原因：<br/>
1、我们数据是周期性更新，分为每天、每周两类，可能存在最近几天新评价出来的没有统计进来，所以导致数据有差异。<br/>
2、买家如果自己主动删掉评价，跟我们上次记录的有差别。<br/>
3、买家的评价由于违规被亚马逊删除了，因此买家页面的Reviews会跟我们暂时不一致。<br/>
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211012/uf4003.png" style="height:871px; width:751px"></p>
我们会实时记录所有数据，如果发现买家数据异常，买家在快现形的信息与实际信息有差异，除非最近一周买家有新的评论等动作，不然基本可以判断该买家账号就有问题。`,
    },
    {
      title: '什么是买家Reviews异常，什么情况下是异常的?',
      id: '9',
      content: `一般情况下，买家Profile页面Reviews显示的数字跟下面实际留下的评论是一样的，如果不一样，基本上可以判断为该账号异常，是不能用来作为产品体验测评的账号。而出现异常的情况一般分为以下几种情况：<br/>
1、买家Reviews显示的数字，比页面展示的实际留下的评论多；比如Reviews显示10条评论，但是下面实际留下的只有8条，有很大可能是由于该买家账号有问题，直接被亚马逊删除了2条评论，这样的账号可以归类为问题账号。<br/>
2、买家Reviews显示的数字，比实际留下的评论异常少；比如Reviews显示1或者0条评论，但是下面实际留下的2条或者更多，该账号可以归类为问题账号，不能用来做体验测评。<br/>
3、买家Reviews显示的数字，比快现形数据库中的评论少；因为快现形监控了买家历史上所有的评论，一旦买家账号留评发生任何问题，快现形都有历史数据，而发生问题后买家页面显示的Reviews数字可能会发生变化，因此大家会看到异常数据。<br/>
建议你查询的买家账号的任何数据，以快现形提供的为准。
<p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211012/uf4002.png" style="height:952px; width:961px"></P>`,
    },
  ],
}

export default config
